import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LastAngebotService {
  private readonly _angebotId$ = new BehaviorSubject<number | null>(null);

  angebotId$: Observable<number | null> = this._angebotId$.asObservable();

  async setzeAngebot(angebotId: number | null) {
    this._angebotId$.next(angebotId);
  }
}
